<template>
  <div class="container">
    <li class="return">
      <span @click="$router.go(-1)"
        ><i class="el-icon-arrow-left"></i>返回</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>订单列表</span>
    </li>

    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入搜索内容"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10"
        clearable
        v-model="status"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in selList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>

    <div class="order-cover-title">
      <div
        class="cover"
        :style="`background-image:url(${$utils.fileUrl(orderData.cover)})`"
      ></div>
      <li>{{ orderData.title }}</li>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column align="center" prop="code" label="订单编号">
      </el-table-column>
      <el-table-column align="center" label="交易时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="交易价格" align="center">
        <template #default="scope"> {{ scope.row.totalPrices }}元 </template>
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="买方名称"
      ></el-table-column>
      <el-table-column label="卖方进度" align="center">
        <template #default="scope">
          {{ orderStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="180" align="center">
        <template #default="scope"> </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      status: "",
      selList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "已下单",
        },
        {
          value: 2,
          label: "交易关闭",
        },
        {
          value: 3,
          label: "交易中",
        },
        {
          value: 4,
          label: "待卖家确认",
        },
        {
          value: 6,
          label: "申请终止交易",
        },
        {
          value: 8,
          label: "交易锁死",
        },
        {
          value: 5,
          label: "待评价",
        },
        {
          value: 18,
          label: "交易结束",
        },
      ],
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        id: this.$route.params.id,
        name: this.searchName,
        status: this.status,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.product.list.getOrderList(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    orderStatus(val) {
      switch (val) {
        case 0:
          return "已下单";
        case 1:
          return "交易已取消";
        case 2:
          return "交易关闭";
        case 3:
          return "交易中";
        case 4:
          return "待卖家确认";
        case 5:
          return "待评价";
        case 6:
          return "申请终止交易";
        case 7:
          return "待评价";
        case 8:
          return "交易锁死";
        case 9:
          return "申请终止交易";
        case 10:
          return "待评价";
        case 11:
          return "交易锁死";
        case 12:
          return "待评价";
        case 13:
          return "评价完成";
        case 18:
          return "交易结束";
      }
    },
  },
  computed: {
    orderData() {
      const data = this.$store.getters["data/getData"];
      return data;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.return {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid $--border-color-base;

  span {
    cursor: pointer;
    font-size: 0.875rem;
    color: $--color-text-regular;
  }
}

.order-cover-title {
  display: flex;
  margin-bottom: 24px;
  align-items: center;

  .cover {
    width: 160px;
    height: 90px;
    margin-right: 24px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  li {
    font-size: 0.875rem;
  }
}

.orderName {
  font-size: 0.875rem;
  margin-bottom: 24px;
  color: $--color-text-regular;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 5px 0;
    color: $--color-primary;
  }

  .atlas {
    display: flex;

    & > div {
      width: 160px;
      height: 90px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  table {
    margin: 10px 0;
    td {
      width: 120px;
      height: 36px;
      font-size: 0.875rem;
      text-align: center;
      vertical-align: middle;
      color: $--color-text-regular;
      border: 1px solid $--border-color-base;
    }
  }

  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      padding: 0;
    }
  }

  .remark {
    .title {
      margin: 24px 0;
      padding-left: 10px;
      font-size: 1.125rem;
      border-left: 2px solid #409eff;
    }

    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>